import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// export function googleCoordsValidator(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const coords = control.value;

//     const coordsInvalid =
//       !coords || // null, undefined, empty
//       (Array.isArray(coords) && coords.length === 0) || // empty array
//       (typeof coords === 'object' && !Array.isArray(coords) && Object.keys(coords).length === 0); // empty object

//     return coordsInvalid ? { invalidAddress: true } : null;
//   };
// }

export function addressValidator(addressKey: string = 'name'): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const address = group.get(addressKey)?.value;
    const coords = group.get('coords')?.value;

    const coordsInvalid =
      !coords || // null, undefined, empty
      (Array.isArray(coords) && coords.length === 0) || // empty array
      (typeof coords === 'object' && !Array.isArray(coords) && Object.keys(coords).length === 0); // empty object

    if (address && coordsInvalid) {
      return { invalidAddress: true };
    }

    return null;
  };
}

